/*
 * Color Visualizer
 */
'use strict';

jQuery($ => {

class ColorVisualizer {
    constructor() {
        this.container = $('.gecko-color-visualizer');

        if (this.container.length) {
            this.tabs();

            this.filters();

            this.initColors();
        }
    }

    tabs() {
        $('.gecko-color-visualizer__type').on('click', (e) => {
            e.preventDefault();
            const tab = $(e.currentTarget).attr('data-tab');
            $('.gecko-color-visualizer__type').removeAttr('data-status');
            $('.gecko-color-visualizer__type[data-tab="' + tab + '"]').attr('data-status', 'active');

            $('.gecko-color-visualizer__tab').removeAttr('data-status');
            $('.gecko-color-visualizer__tab[data-tab="' + tab + '"]').attr('data-status', 'active');
        });
    }

    hideAllFilters() {
        $('.gecko-color-visualizer__select').removeAttr('data-visible');
    }

    filters() {
        $(document).on('mousedown', (e) => {
            // e.preventDefault();
            const target = $(e.target);
            const select = target.parents('.gecko-color-visualizer__select');
            const overlay = target.parents('.gecko-color-visualizer__svg-overlay');
            const floatingSelect = target.parents('.gecko-color-visualizer__floating-select');

            if (select.length < 1) {
                this.hideAllFilters();
            }

            if (overlay.length < 1 && floatingSelect.length < 1) {
                this.hideFloatingSelect();
            }
        });

        $('.gecko-color-visualizer__select').each((i, el) => {
            const selected = $(el).find('.gecko-color-visualizer__selected');

            selected.on('mouseup', (e) => {
                e.preventDefault();
                const target = $(e.currentTarget);
                const select = target.parents('.gecko-color-visualizer__select');

                if (select.attr('data-visible') === 'true') {
                    select.removeAttr('data-visible');
                } else {
                    this.hideAllFilters();
                    select.attr('data-visible', 'true');
                }
            });
        });

        $('.gecko-color-visualizer__option').on('click', (e) => {
            e.preventDefault();

            const option = $(e.currentTarget);
            const select = option.parents('.gecko-color-visualizer__select');
            const floatingSelect = option.parents('.gecko-color-visualizer__floating-select');

            const color = option.attr('data-color');
            const colorName = option.text();

            if (select.length > 0) {
                const filter = select.attr('data-filter');
                const type = select.attr('data-type');

                select.find('.gecko-color-visualizer__option').removeAttr('data-status');
                option.attr('data-status', 'selected');

                this.updateSelected(filter, type, color, colorName);
                this.updateOverlay(filter, type, color);

                this.hideAllFilters();
            }

            if (floatingSelect.length > 0) {
                const filter = floatingSelect.attr('data-filter');
                const type = floatingSelect.attr('data-type');

                floatingSelect.find('.gecko-color-visualizer__option').removeAttr('data-status');
                option.attr('data-status', 'selected');

                this.updateSelected(filter, type, color, colorName);
                this.updateOverlay(filter, type, color);

                this.hideFloatingSelect();
            }
        });

        $('.gecko-color-visualizer__svg-overlay').on('click', (e) => {
            e.preventDefault();

            const overlay = $(e.currentTarget);
            const title = overlay.attr('data-filter-title');
            const filter = overlay.attr('data-filter');
            const type = overlay.attr('data-type');
            const color = overlay.attr('data-color');

            const x = e.offsetX;
            const y = e.offsetY;

            this.showFloatingSelect(overlay, title, filter, type, color, x, y);
        });
    }

    showFloatingSelect(overlay, title, filter, type, color, x, y) {
        const parent = overlay.parents('.gecko-color-visualizer__image');
        const select = parent.find('.gecko-color-visualizer__floating-select');
        const floatingTitle = select.find('.gecko-color-visualizer__floating-title');

        select.find('.gecko-color-visualizer__option').removeAttr('data-status');
        select.find('.gecko-color-visualizer__option[data-color="'+color+'"]').attr('data-status', 'selected');

        floatingTitle.text(title);

        if (select.attr('data-status') === 'active' && select.attr('data-filter') === filter) {
            this.hideFloatingSelect();
        } else {
            select.attr('data-status', 'active');
        }

        select.attr({
            'data-filter': filter,
            'data-type': type,
        });


        // Position the popup
        const bounds = {
            x: parent.outerWidth(),
            y: parent.outerHeight(),
        }

        let leftOffset = 0;
        if ( (x + select.outerWidth()) > (bounds.x - 48)) {
            leftOffset = select.outerWidth() + 48;
        }

        let topOffset = 0;
        if ( (y + (select.outerHeight() / 2)) > (bounds.y - 24) ) {
            let diff = bounds.y - (y + (select.outerHeight() / 2))
            topOffset = topOffset + diff - 24;
        }

        let left = x + 24 - leftOffset;
        let top = y - (select.outerHeight() / 2) + topOffset;

        select.css({
            top: top,
            left: left,
        });
    }

    hideFloatingSelect() {
        $('.gecko-color-visualizer__floating-select').removeAttr('data-status');
    }

    initColors() {
        const colorData = document.getElementById('gecko-color-visualizer__color-data');
        if (colorData) {
            this.colors = JSON.parse(colorData.innerHTML);

            $('.gecko-color-visualizer__select').each((i, el) => {
                if (!$(el).hasClass('.gecko-color-visualizer__select--floating')) {
                    const select = $(el);
                    const filter = select.attr('data-filter');
                    const type = select.attr('data-type');
                    const color = select.find('.gecko-color-visualizer__selected').attr('data-color');

                    this.updateOverlay(filter, type, color);
                }
            });
        }
    }

    updateSelected(filter, type, color, colorName) {
        const select = $('.gecko-color-visualizer__select[data-filter="' + filter + '"][data-type="' + type + '"]');
        const selected = select.find('.gecko-color-visualizer__selected');
        selected.attr('data-color', color)
            .css('background-color', color)
            .find('.gecko-color-visualizer__color-title')
                .text(colorName);

        select.find('.gecko-color-visualizer__option').removeAttr('data-status');

        select.find('.gecko-color-visualizer__option').removeAttr('data-status');
        select.find('.gecko-color-visualizer__option[data-color="'+color+'"]').attr('data-status', 'selected');
    }

    updateOverlay(filter, type, color) {
        const overlay = $('.gecko-color-visualizer__svg-overlay[data-filter="' + filter + '"][data-type="' + type + '"]');

        overlay.attr('data-color', color);

        overlay.css({
            'fill': color,
        });
    }
}

const colorVis = new ColorVisualizer();

});
